import * as React from 'react';
import Button from '@mui/material/Button';
import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import {Box} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {WhiteCrossOutlined, BlackCrossOutlined} from '@jobseeker/lotus/icons';
import {PropTypes} from '../type';
import CircularDesign from '@jobseeker/lotus/elements/CircularDesign';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';

const BootstrapDialog = styled(Dialog)(({theme}) => ({
  '.MuiDialog-paper': {
    borderRadius: theme.spacing(2),
  },
  [theme.breakpoints.down('md')]: {
    '.MuiDialog-paper': {
      borderRadius: theme.spacing(0),
    },
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const Component = ({title, subtitle, invertedTitle, ...props}: PropTypes) => {
  const handleClose = (event: any) => {
    if (props.onClose) props.onClose(event, 'escapeKeyDown');
  };
  const isLarge = useIsLargeDevice();
  return (
    <div>
      <BootstrapDialog {...props} fullScreen={props.fullScreen ?? !isLarge}>
        <Box
          sx={{
            py: subtitle ? 0 : 1,
            overflow: 'hidden',
            position: 'relative',
            background: props.hirist
              ? 'linear-gradient(90deg, #E3E9F0 0%, #F3F5FB 100%)'
              : 'linear-gradient(90deg, #225448 0%, #7E9F67 100%)',
            pr: 6,
          }}
        >
          <DialogTitle>
            {invertedTitle ? (
              <>
                {subtitle && (
                  <Typography color="primary.contrastText" variant="body2">
                    {subtitle}
                  </Typography>
                )}
                <Typography
                  color="primary.contrastText"
                  fontSize={{xxs: 18, md: 20}}
                  fontWeight={600}
                >
                  {title}
                </Typography>
              </>
            ) : (
              <>
                <Typography
                  color={props.hirist ? '#000' : 'primary.contrastText'}
                  fontSize={{xxs: 18, md: 20}}
                  fontWeight={600}
                >
                  {title}
                </Typography>
                {subtitle && (
                  <Typography
                    color="primary.contrastText"
                    variant="subtitle1"
                    fontWeight={600}
                  >
                    {subtitle}
                  </Typography>
                )}
              </>
            )}
          </DialogTitle>
          <Box
            sx={{
              position: 'absolute',
              right: 8,
              zIndex: 1,
              top: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <IconButton aria-label="close" onClick={handleClose}>
              <Image
                width={24}
                height={24}
                src={props.hirist ? BlackCrossOutlined : WhiteCrossOutlined}
                alt={'white cross'}
                // layout="fill"
                // objectFit="cover"
              />
            </IconButton>
          </Box>
          {/* <Box
            sx={{
              position: 'absolute',
              zIndex: 0,
              top: -93,
              right: -50,
              opacity: 0.08,
            }}
          >
            <CircularDesign size={140} />
          </Box>
          <Box
            sx={{position: 'absolute', bottom: -83, left: -40, opacity: 0.05}}
          >
            <CircularDesign size={125} />
          </Box> */}
        </Box>
        <DialogContent
          sx={{padding: 1, maxHeight: {xxs: 'calc(100vh - 75px)', sm: '680px'}}}
        >
          {props.children}
        </DialogContent>
        {props.footer}
      </BootstrapDialog>
    </div>
  );
};

export default Component;
